import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard/Button'
import {getHeadBranchText} from '../utils/branch-label'
import {PullRequestBranchName} from './PullRequestBranchName'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export interface PullRequestHeadBranchNameProps {
  baseRepositoryOwnerLogin: string
  headBranch: string
  headRepositoryOwnerLogin?: string
  headRepositoryName?: string
  isInAdvisoryRepo?: boolean
}

/** Displays the clipboard-copyable head branch name of a pull request. */
export function PullRequestHeadBranchName({
  baseRepositoryOwnerLogin,
  headBranch,
  headRepositoryOwnerLogin = '',
  headRepositoryName = '',
  isInAdvisoryRepo,
}: PullRequestHeadBranchNameProps) {
  const showUpdatedHeader = isFeatureEnabled('updated_pull_request_header')

  const text = getHeadBranchText(
    baseRepositoryOwnerLogin,
    headRepositoryOwnerLogin,
    headRepositoryName,
    headBranch,
    isInAdvisoryRepo,
  )

  return showUpdatedHeader ? (
    <PullRequestBranchName
      branch={headBranch}
      branchText={text}
      repositoryName={headRepositoryName}
      repositoryOwner={headRepositoryOwnerLogin}
      button={
        <CopyToClipboardButton
          ariaLabel="Copy head branch name to clipboard"
          size="small"
          textToCopy={headRepositoryOwnerLogin ? text : headBranch}
        />
      }
    />
  ) : (
    <div className="d-flex flex-items-center overflow-hidden gap-1">
      <PullRequestBranchName
        branch={headBranch}
        branchText={text}
        repositoryName={headRepositoryName}
        repositoryOwner={headRepositoryOwnerLogin}
      />
      <CopyToClipboardButton
        ariaLabel="Copy head branch name to clipboard"
        size="small"
        textToCopy={headRepositoryOwnerLogin ? text : headBranch}
      />
    </div>
  )
}
